import { render, staticRenderFns } from "./PortingInformation.vue?vue&type=template&id=66a5d17e&scoped=true&"
import script from "./PortingInformation.vue?vue&type=script&lang=js&"
export * from "./PortingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5d17e",
  null
  
)

export default component.exports